import { SxProps, Theme } from '@mui/material';

export const storeLocatorHeaderInfoSX = (theme: Theme, isSelected: boolean): SxProps<Theme> => ({
	display: 'flex',
	alignItems: 'center',
	cursor: 'pointer',
	padding: '10px',
	minWidth: '174px',
	gap: '10px',
	flexDirection: 'row',
	borderRadius: '3px',
	...(isSelected && { backgroundColor: 'grey.50' }),
	'&:hover': {
		backgroundColor: 'grey.50',
	},
	[theme.breakpoints.down('md')]: {
		gap: '2px',
		flexDirection: 'column',
	},
});

export const storeLocatorHeaderInfoStoreSX: SxProps = {
	display: 'flex',
	gap: '5px',
	alignItems: 'center',
};

export const storeLocatorHeaderInfoStoreNameSX: SxProps = {
	fontWeight: 'normal',
	cursor: 'pointer',
	color: 'secondary.main',
	'&:hover': {
		textDecoration: 'underline',
	},
};

export const storeLocatorHeaderInfoStoreIConSX = (isSelected: boolean): SxProps<Theme> => ({
	fontSize: '16px !important',
	color: 'grey.500',
	animation: 'none !important',
	opacity: '1 !important',
	...(isSelected && { color: 'primary.main' }),
});

export const storeLocatorInfoIconSX = (isSelected: boolean): SxProps<Theme> => ({
	width: '16px',
	height: '16px',
	...(isSelected && { color: 'primary.main' }),
});
